import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes';

const KakaoPayCancelPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('kakaoPayFlow') === 'pcMembershipPendingRegistration') {
      localStorage.removeItem('kakaoPayFlow');
      localStorage.removeItem('kakaoPayPendingSubscriptionChannel');
      localStorage.removeItem('kakaoPayRequestInfo');
      localStorage.removeItem('kakaoPayResponseInfo');
      localStorage.removeItem('subscriptionNo');
      navigate(`${ROUTES.moreMembership}?pendingSubscription=fail`, { replace: true });
      return;
    }

    if (localStorage.getItem('kakaoPayFlow') === 'mobileMembership') {
      localStorage.removeItem('kakaoPayFlow');
      navigate(`${ROUTES.mobileKakaoPayCancel}?result=fail`, { replace: true });
      return;
    }

    const isPaymentChange = localStorage.getItem('kakaoPayPaymentChange') === 'true';
    localStorage.removeItem('kakaoPayPaymentChange');

    navigate(
      `${ROUTES.moreMembership}?result=fail${isPaymentChange ? '&paymentChange=true' : ''}`,
      {
        replace: true,
      },
    );
  }, [navigate]);

  return null;
};

export default KakaoPayCancelPage;
